/**
 * 输入输出全屏展示组件
 * zxw
 * 创建时间 2026-02-02
 */

import CNF from '../../incs/Config';
import { useState, useEffect } from 'react';
import { Modal, Typography } from 'antd';

import { XMarkdown } from '@ant-design/x-markdown';
import Latex from '@ant-design/x-markdown/plugins/Latex';   // 公式
import { CodeHighlighter, } from '@ant-design/x';
import '@ant-design/x-markdown/themes/light.css';

// 思维链
import XinYuanThink from './XinYuanThink';
import {
    ImageSkeleton,
    IncompleteLink,
    TableSkeleton,
    HtmlSkeleton,
    IncompleteEmphasis,
    IncompleteInlineCode,
    WelcomeCard,
    Code,
} from '../../components/Incomplete';

const { Text } = Typography;

const IOPutFullScreen = (props) => {
    const [open, setOpen] = useState(false);

    const cancel = () => { setOpen(false); };

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const className = props.isDarkMode ? 'x-markdown-dark' : 'x-markdown-light';

    return <Modal
        title={<span style={{ color: CNF.baseTextColor }}>{props.title}</span>}
        open={open}
        onCancel={cancel}
        footer={null}
        width={'100%'}
        style={{
            top: 20,
        }}
        styles={{
            container: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            header: {
                paddingLeft: 20,
                paddingBottom: 12,
                borderBottom: `1px solid ${CNF.baseBorderSolidColor}`,
            },
            body: {
                padding: 20,
            }
        }}
        destroyOnHidden={true}
    ><div style={{
        maxHeight: 'calc(100vh - 160px)',
        scrollbarColor: '#d9d9d9 transparent',
        scrollbarWidth: 'thin',
        overflowY: 'auto',
    }}>
            {
                props.format === 'Json' ? <CodeHighlighter
                    lang='json'
                    styles={{
                        header: {
                            display: 'none',
                        },
                        code: {
                            border: 0,
                            background: '#fff'
                        }
                    }}>{JSON.stringify(props.content, null, 2)}</CodeHighlighter>
                    :
                    props.format === 'Text' ? <Text style={{ color: CNF.baseTextColor, fontSize: CNF.fontSizeSM, }}>{JSON.stringify(props.content)}</Text>
                        :
                        <XMarkdown
                            content={props.content}
                            className={className}
                            paragraphTag='div'
                            openLinksInNewTab
                            dompurifyConfig={{ ADD_ATTR: ['icon', 'description'] }}
                            style={{
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word',
                                overflowX: 'hidden',
                                padding: 8,
                                width: 'auto',
                            }}
                            components={{
                                code: Code,
                                'think': XinYuanThink,
                                'incomplete-image': ImageSkeleton,
                                'incomplete-link': IncompleteLink,
                                'incomplete-table': TableSkeleton,
                                'incomplete-html': HtmlSkeleton,
                                'incomplete-emphasis': IncompleteEmphasis,
                                'incomplete-inline-code': IncompleteInlineCode,
                                welcome: WelcomeCard,
                            }}
                            config={{
                                extensions: Latex(),
                            }}
                        />
            }
        </div>
    </Modal >
}

export default IOPutFullScreen;